import { render, staticRenderFns } from "./DatavDesignPreview.vue?vue&type=template&id=e9bbfec0&scoped=true"
import script from "./DatavDesignPreview.vue?vue&type=script&lang=js"
export * from "./DatavDesignPreview.vue?vue&type=script&lang=js"
import style0 from "./DatavDesignPreview.vue?vue&type=style&index=0&id=e9bbfec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bbfec0",
  null
  
)

export default component.exports